// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2024 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import * as React from "react";

const SaveCart: React.FC = () => {
    return (
        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 11 12">
            <path
                fill="currentColor"
                d="M8.205 1.3A1.867 1.867 0 0 0 6.88.75H1.875A1.877 1.877 0 0 0 0 2.625v6.75c0 1.034.84 1.875 1.875 1.875h6.75A1.877 1.877 0 0 0 10.5 9.375V4.371a1.86 1.86 0 0 0-.55-1.326L8.206 1.299Zm-5.955.2h4.5v2.25h-4.5V1.5Zm7.5 7.875c0 .62-.505 1.125-1.125 1.125h-6.75C1.255 10.5.75 9.996.75 9.375v-6.75c0-.488.315-.9.75-1.056V3.75c0 .414.336.75.75.75h4.5a.75.75 0 0 0 .75-.75V1.688c.062.041.121.088.174.142L9.42 3.576c.213.212.33.495.33.795v5.004Zm-4.5-3.75A1.877 1.877 0 0 0 3.375 7.5c0 1.034.84 1.875 1.875 1.875A1.877 1.877 0 0 0 7.125 7.5 1.877 1.877 0 0 0 5.25 5.625Zm0 3a1.126 1.126 0 0 1 0-2.25 1.126 1.126 0 0 1 0 2.25Z"
                opacity=".66"
            />
        </svg>
    );
};

export default React.memo(SaveCart);
